import React from 'react'
import { Select } from 'elentari'
import { Field } from 'react-final-form'

const EmpresaSelect = props => {
  return (
    <Field
      fullWidth
      hideEmpty
      component={Select}
      options={[
        { label: 'G10 Transportes', value: 1 },
        { label: 'Transpanorama', value: 2 }
      ]}
      label="Empresa"
      name="empresaId"
      {...props}
    />
  )
}

export default EmpresaSelect
